
export function areDependenciesEqual(deps1: readonly unknown[], deps2: readonly unknown[], depth?: number) {
    if (deps1.length !== deps2.length || (depth && depth > 2))
        return false;

    for (let index = 0; index < deps1.length; ++index) {
        const d1: unknown = deps1[index];
        const d2: unknown = deps2[index];
        if (d1 !== d2) {
            if (Array.isArray(d1) && Array.isArray(d2))
                return areDependenciesEqual(d1, d2, (depth ?? 0) + 1);
            return false;
        }
    }
    return true;
}
